"use strict";

import React, { useState, useEffect } from "react";
import SwiperCore, { Navigation, Lazy, Pagination, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION } from "react-image-magnifiers";
import mqListener from "../../mqListener";
import ProductGalleryMediumUp from "./ProductGalleryMediumUp";
import ProductGalleryFullScreen from "./ProductGalleryFullScreen";
import ProductGallerySlide from "./ProductGallerySlide";
import ProductGalleryThumbnailSlide from "./ProductGalleryThumbnailSlide";
import ProductGalleryToolbar from "./ProductGalleryToolbar";

SwiperCore.use([Navigation, Lazy, Pagination, Thumbs]);

const ProductGallery = ({ slides = [] }) => {
    const [mQuery, setMQuery] = useState(null);
    const [isMediumUp, setIsMediumUp] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [galleryThumbController, setGalleryThumbController] = useState(null);
    const [isAtBeginning, setIsAtBeginning] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);
    const largeImgPath = "/assets/img/products/large/";
    const zoomImgPath = "/assets/img/products/zoom/";
    const loopedSlides = !!slides.length && slides.length >= 1 ? 1 : 0;
    const thumbnailSlidesPerView = 4;
    const spaceBetween = 10;
    const lazyLoading = {
        preLoaderClassName: "loading-lazy-preloader",
        preLoaderElementClassName: "loading-lazy-preloader loading loading--w-flip loading--center-flex loading--cover",
        imgPlaceholderSrc: "/assets/img/style/product-placeholder--transparent.png",
    };
    useEffect(() => {
        setMQuery(() => {
            return mqListener("(min-width: 640px)", handleMQChange);
        });
        return () => {
            if (mQuery) {
                mQuery.removeListener(handleMQChange);
            }
        };
    }, []);

    useEffect(() => {
        //
    }, [currentIndex]);

    function handleMQChange(mq) {
        setIsMediumUp(() => {
            return mq.matches;
        });

        // Reset thumb controller when switching between mobile and desktop
        if (galleryThumbController) {
            setGalleryThumbController(null);
        }
    }

    function handleSlideChange(gallery) {
        //gallery.allowTouchMove = true;
        setCurrentIndex(gallery.realIndex);
    }

    function toggleIsFullScreen(e) {
        e.preventDefault();
        setIsFullScreen(() => {
            return !isFullScreen;
        });
    }

    function onFullScreenClick(e) {
        toggleIsFullScreen(e);
    }

    // Check if we're on the configurable product page by looking for the unique ID
    const isConfigurableProductPage = document.getElementById("configurable-product-page") !== null;

    if (!!slides && slides.length) {
        return (
            <React.Fragment>
                {!isMediumUp && !!slides && !!slides.length && (
                    <React.Fragment>
                        {(slides.length === 1 && (
                            <React.Fragment>
                                <ul className="product-images__list slides">
                                    <li className="product-images__list-item slide slide--active">
                                        <ProductGallerySlide slide={slides[0]} slideAltText={`Product Image`} />
                                    </li>
                                </ul>
                                <ProductGalleryToolbar
                                    className="product-detail__slides__toolbar__container--medium-up"
                                    style={{ borderBottom: "1px solid #bbbbbb" }}
                                    index={currentIndex}
                                    slidesLength={slides.length}
                                    onFullScreenClick={onFullScreenClick}
                                />
                            </React.Fragment>
                        )) || (
                            <React.Fragment>
                                <Swiper
                                    thumbs={{
                                        swiper:
                                            galleryThumbController && galleryThumbController.destroyed !== true
                                                ? galleryThumbController
                                                : null,
                                    }}
                                    className={"product-detail__slides__container"}
                                    tag="div"
                                    wrapperTag="ul"
                                    navigation
                                    slidesPerView={1}
                                    grabCursor={false}
                                    simulateTouch={false}
                                    loop={true}
                                    loopedSlides={loopedSlides}
                                    onSwiper={(swiper) => {
                                        swiper.slideToLoop(currentIndex);
                                        swiper.on("slideChange", function () {
                                            handleSlideChange(swiper);
                                        });
                                    }}>
                                    {slides.map((slide, index) => (
                                        <SwiperSlide
                                            tag="li"
                                            style={{ background: "#eeeeee" }}
                                            key={`slideKey0-${index}`}>
                                            <ProductGallerySlide slide={slide} slideAltText={`Product Image`} />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <ProductGalleryToolbar
                                    className="product-detail__slides__toolbar__container--medium-up"
                                    index={currentIndex}
                                    slidesLength={slides.length}
                                    onFullScreenClick={onFullScreenClick}
                                />
                                {slides.length > 1 && isConfigurableProductPage && (
                                    <div
                                        className="product-detail__slides__thumbnail__container"
                                        style={{
                                            position: "relative",
                                            padding: "0 30px",
                                            marginTop: "10px",
                                            userSelect: "none",
                                            WebkitUserSelect: "none",
                                            MozUserSelect: "none",
                                            msUserSelect: "none",
                                            WebkitTouchCallout: "none",
                                            WebkitTapHighlightColor: "transparent",
                                        }}>
                                        <div
                                            className="thumbnail-swiper-button-prev"
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                zIndex: 10,
                                                cursor: "pointer",
                                                background: "transparent !important",
                                                borderRadius: "50%",
                                                padding: "5px",
                                                boxShadow: "none !important",
                                                display: slides.length <= thumbnailSlidesPerView ? "none" : "block",
                                            }}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke={isAtBeginning ? "#B4CDE1" : "#268de1"}
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <polyline points="15 18 9 12 15 6"></polyline>
                                            </svg>
                                        </div>
                                        <div
                                            className="thumbnail-swiper-button-next"
                                            style={{
                                                position: "absolute",
                                                right: 0,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                zIndex: 10,
                                                cursor: "pointer",
                                                background: "transparent !important",
                                                borderRadius: "50%",
                                                padding: "5px",
                                                boxShadow: "none !important",
                                                display: slides.length <= thumbnailSlidesPerView ? "none" : "block",
                                            }}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke={isAtEnd ? "#B4CDE1" : "#268de1"}
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                        <Swiper
                                            tag="div"
                                            wrapperTag="ul"
                                            slidesPerView={thumbnailSlidesPerView}
                                            watchSlidesProgress={true}
                                            watchSlidesVisibility={true}
                                            spaceBetween={spaceBetween}
                                            loop={false}
                                            navigation={{
                                                nextEl: ".thumbnail-swiper-button-next",
                                                prevEl: ".thumbnail-swiper-button-prev",
                                            }}
                                            lazy={{
                                                loadPrevNext: true,
                                                preloaderClass: lazyLoading.preLoaderClassName || "",
                                            }}
                                            onSwiper={(swiper) => {
                                                if (swiper && !swiper.destroyed) {
                                                    setGalleryThumbController(() => {
                                                        return swiper;
                                                    });
                                                }

                                                // Set initial state
                                                setIsAtBeginning(swiper.isBeginning);
                                                setIsAtEnd(swiper.isEnd);

                                                // Listen for slide changes
                                                swiper.on("slideChange", function () {
                                                    setIsAtBeginning(swiper.isBeginning);
                                                    setIsAtEnd(swiper.isEnd);
                                                    swiper.lazy.load();
                                                });

                                                swiper.once("slideChange", function () {
                                                    swiper.lazy.load();
                                                });
                                            }}>
                                            {slides.map((slide, index) => (
                                                <SwiperSlide
                                                    tag="li"
                                                    key={`slideThumb0-${index}`}
                                                    style={{ background: "#eeeeee" }}>
                                                    <ProductGalleryThumbnailSlide
                                                        thumbnail={slide}
                                                        imgAlt={"Product Slide Thumbnail"}
                                                        lazyLoad={index > 2}
                                                        lazyLoading={lazyLoading}
                                                    />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                <ProductGalleryMediumUp
                    slides={slides}
                    currentIndex={currentIndex}
                    largeImgPath={largeImgPath}
                    zoomImgPath={zoomImgPath}
                    isMediumUp={isMediumUp}
                    isFullScreen={isFullScreen}
                    onSlideChange={handleSlideChange}
                    onFullScreenClick={toggleIsFullScreen}
                    lazyLoading={lazyLoading}
                />
                <ProductGalleryFullScreen
                    slides={slides}
                    currentIndex={currentIndex}
                    largeImgPath={largeImgPath}
                    zoomImgPath={zoomImgPath}
                    isMediumUp={isMediumUp}
                    onSlideChange={handleSlideChange}
                    showFullScreen={isFullScreen}
                    onFullScreenClick={toggleIsFullScreen}
                    lazyLoading={lazyLoading}
                />
            </React.Fragment>
        );
    } else return null;
};

export default ProductGallery;
